<template>
  <div class="pointconfig-container">
    <pointfilter
      v-if="pointStore.products.List !== null && pointStore.categories.List !== null && pointStore.depths.List !== null"
      :filter="filter"
      :products="products"
      :categories="categories"
      :depths="depths"
      :isMobile="isMobile"
      @toggleSelected="toggleSelectedFilter"
      @toggleProduct="toggleSelectedProduct"
      @toggleDepth="toggleSelectedDepth"
      @toggleCategory="toggleSelectedCategory"
    >
    </pointfilter>

    <pointlist
      v-if="pointStore.points !== null"
      :points="points"
      :enabledPoints="enabledPoints"
      :selectedPoint="selectedPoint"
      :search="search"
      :filter="filter"
      :searchResults="searchResults"
      :selectedProducts="selectedProducts"
      :selectedCategories="selectedCategories"
      :selectedDepths="selectedDepths"
      @togglePoint="togglePoint"
      @click="isOpen = true"
      @clearFilter="clearFilter"
      @marathon="marathon">
    >
      @clearFilter="clearFilter"
      @marathon="marathon">
    </pointlist>
  </div>
</template>

<script setup>
import { usePointStore } from './store/store';
import { ref } from "vue";

import pointfilter from '../pointConfigurator/components/filter.vue';
import pointlist from '../pointConfigurator/components/point-list.vue';

const pointStore = usePointStore();
const isOpen = ref(false);
pointStore.setInitialState();

let isMobile = ref(false);

function windowIsMobile() {
  if (document.documentElement.clientWidth < 768) {
    isMobile = true;
  }
  else {
    isMobile = false;

  }
}

function toggleSelectedFilter(object) {
  if (!object.Disabled) {
    object.Selected = !object.Selected;
  }
}

function toggleSelectedProduct(product) {
  disableDepth(product);
  disableCategory(product);
  filterPoint();
}
function toggleSelectedCategory(category) {
  disableProductByCategory(category);
  filterPoint();
}
function toggleSelectedDepth(depth) {
  disableProductByDepth(depth);
  filterPoint();
}

function filterPoint() {
  //loop through points and check categories, depths and products and set disabled if one criterion doesn't match
  for (var i = 0; i < pointStore.points.length; i++) {
    var pointDisabled = false;
    var selectedProductsNumber = 0;
    for (var j = 0; j < pointStore.selectedProducts.length; j++) {
      selectedProductsNumber++;
      var productIndex = pointStore.points[i].Products.findIndex(x => x.Id === pointStore.selectedProducts[j].Id);
      if (productIndex < 0) {
        pointStore.points[i].Disabled = true;
        pointDisabled = true;
      }
      else {
        pointStore.points[i].Disabled = false;
        pointDisabled = false;
        break;
      }
    }
    if (selectedProductsNumber === 0) {
      pointStore.points[i].Disabled = false;
    }
    if (pointDisabled === false) {
      var selectedDepthsNumber = 0;
      for (var j = 0; j < pointStore.selectedDepths.length; j++) {
        selectedDepthsNumber++;
        if (pointStore.selectedDepths[j].MaxDepth <= pointStore.points[i].MaxDepth && pointStore.selectedDepths[j].MaxDepth > pointStore.points[i].MinDepth) {
          pointStore.points[i].Disabled = false;
          pointDisabled = false;
          break;
        }
        else {
          pointStore.points[i].Disabled = true;
          pointDisabled = true;
        }
      }
      if (selectedDepthsNumber === 0) {
        pointStore.points[i].Disabled = false;
      }
      if (pointDisabled === false) {
        var selectedCategoriesNumber = 0;
        for (var j = 0; j < pointStore.selectedCategories.length; j++) {
          selectedCategoriesNumber++;
          var categoryIndex = pointStore.points[i].Categories.findIndex(x => x.Id === pointStore.selectedCategories[j].Id);
          if (categoryIndex < 0) {
            pointStore.points[i].Disabled = true;
            pointDisabled = true;
          }
          else {
            pointStore.points[i].Disabled = false;
            pointDisabled = false;
            break;
          }
        }
        if (selectedCategoriesNumber === 0) {
          pointStore.points[i].Disabled = false;
        }
      }
    }
    if (pointDisabled && pointStore.points[i].Selected) {
      pointStore.points[i].Selected = false;
    }
  }
}

function disableDepth(product) {
  var depthIndex = pointStore.depths.List.findIndex(x => x.MaxDepth === parseInt(product.MaxDepth));
  if (product.Selected) {
    for (var i = 0; i < depthIndex + 1; i++) {
      pointStore.depths.List[i].Disabled = false;
    }
    for (var i = depthIndex + 1; i < pointStore.depths.List.length; i++) {
      pointStore.depths.List[i].Disabled = true;
      for (var j = 0; j < pointStore.selectedProducts.length; j++) {
        if (pointStore.selectedProducts[j] !== product) {
          if (pointStore.selectedProducts[j].MaxDepth >= pointStore.depths.List[i].MaxDepth) {
            pointStore.depths.List[i].Disabled = false;
          }
        }
      }
    }
  }
  else {
    for (var i = depthIndex + 1; i < pointStore.depths.List.length; i++) {
      pointStore.depths.List[i].Disabled = false;
    }
    for (var i = 0; i < pointStore.depths.List.length; i++) {
      for (var j = 0; j < pointStore.selectedProducts.length; j++) {
        if (pointStore.selectedProducts[j].MaxDepth >= pointStore.depths.List[i].MaxDepth) {
          pointStore.depths.List[i].Disabled = false;
          break;
        }
        else {
          pointStore.depths.List[i].Disabled = true;
        }
      }
    }
  }
}

function disableCategory(product) {
  if (product.Selected) {
    for (var i = 0; i < pointStore.categories.List.length; i++) {
      var categoryIndex = product.Categories.findIndex(x => x.Id === pointStore.categories.List[i].Id);
      if (categoryIndex < 0) {
        pointStore.categories.List[i].Disabled = true;
        for (var j = 0; j < pointStore.selectedProducts.length; j++) {
          if (pointStore.selectedProducts[j] !== product) {
            categoryIndex = pointStore.selectedProducts[j].Categories.findIndex(x => x.Id === pointStore.categories.List[i].Id);
            if (categoryIndex >= 0) {
              pointStore.categories.List[i].Disabled = false;
            }
          }
        }
      }
      else {
        pointStore.categories.List[i].Disabled = false;
      }
    }
  }
  else {
    for (var i = 0; i < pointStore.categories.List.length; i++) {
      var categoryIndex = product.Categories.findIndex(x => x.Id === pointStore.categories.List[i].Id);
      var categoryExists = 0;
      if (categoryIndex < 0) {
        pointStore.categories.List[i].Disabled = false;
      }
      for (var j = 0; j < pointStore.selectedProducts.length; j++) {
        categoryIndex = pointStore.selectedProducts[j].Categories.findIndex(x => x.Id === pointStore.categories.List[i].Id);
        if (categoryIndex < 0) {
          categoryExists++;
        }
        else {
          categoryExists = 0;
          break;
        }
      }
      if (categoryExists > 0) {
        pointStore.categories.List[i].Disabled = true;
      }
    }
  }
}

function disableProductByDepth(depth) {
  for (var i = 0; i < pointStore.products.List.length; i++) {
    if ((depth.Selected && depth.MaxDepth <= pointStore.products.List[i].MaxDepth) ||
      (!depth.Selected && pointStore.selectedCategories.length === 0 && pointStore.selectedDepths.length === 0)) {
      pointStore.products.List[i].Disabled = false;
    }
    else {
      pointStore.products.List[i].Disabled = true;
      for (var j = 0; j < pointStore.selectedDepths.length; j++) {
        if (pointStore.selectedDepths[j] !== depth && pointStore.selectedDepths[j].MaxDepth <= pointStore.products.List[i].MaxDepth) {
          pointStore.products.List[i].Disabled = false;
          break;
        }
      }
      if (pointStore.products.List[i].Disabled === true) {
        for (var k = 0; k < pointStore.selectedCategories.length; k++) {
          var productIndex = pointStore.products.List[i].Categories.findIndex(x => x.Id === pointStore.selectedCategories[k].Id);
          if (productIndex >= 0) {
            pointStore.products.List[i].Disabled = false;
            break;
          }
        }
      }
    }
  }
}

function disableProductByCategory(category) {
  for (var i = 0; i < pointStore.products.List.length; i++) {
    var productIndex = pointStore.products.List[i].Categories.findIndex(x => x.Id === category.Id);
    if ((category.Selected && productIndex >= 0) ||
      (!category.Selected && pointStore.selectedCategories.length === 0 && pointStore.selectedDepths.length === 0)) {
      pointStore.products.List[i].Disabled = false;
    }
    else {
      pointStore.products.List[i].Disabled = true;
      for (var k = 0; k < pointStore.selectedCategories.length; k++) {
        productIndex = pointStore.products.List[i].Categories.findIndex(x => x.Id === pointStore.selectedCategories[k].Id);
        if (pointStore.selectedCategories[j] !== category && productIndex >= 0) {
          pointStore.products.List[i].Disabled = false;
          break;
        }
      }
      if (pointStore.products.List[i].Disabled === true) {
        for (var j = 0; j < pointStore.selectedDepths.length; j++) {
          if (pointStore.selectedDepths[j].MaxDepth <= pointStore.products.List[i].MaxDepth) {
            pointStore.products.List[i].Disabled = false;
            break;
          }
        }
      }
    }
  }
}

function marathon(point) {
  var pointIndex = pointStore.points.findIndex(x => x.ArticleNr === point.MarathonLink);
  togglePoint(pointStore.points[pointIndex], true);
}

function togglePoint(point, marathon) {
  if (!point.Disabled) {
    var scrollArea = document.getElementById('scroll-area');
    var pointOffset = document.getElementById(point.ArticleNr).offsetLeft;
    if (marathon) {
      for (var i = 0; i < pointStore.points.length; i++) {
        if (pointStore.points[i] !== point) {
          pointStore.points[i].Selected = false;
        }
      }

      if (scrollArea.scrollWidth > window.outerWidth) {
        scrollUp();
        animateScroll(pointOffset, scrollArea);
        setTimeout(function () {
          point.Selected = true;
        }, 500);

      }
      else {
        scrollUp();
        point.Selected = true;
      }
    }
    else {
      point.Selected = !point.Selected;
      if (point.Selected) {
        scrollUp();
        animateScroll(pointOffset, scrollArea);
        for (var i = 0; i < pointStore.points.length; i++) {
          if (pointStore.points[i] !== point) {
            pointStore.points[i].Selected = false;
          }
        }
      }
    }
  }
}

function scrollUp() {
  // TODO Vad ska göras här?
  return;
}
function animateScroll() {
  // TODO Vad ska göras här?
  return;
}

function clearFilter() {
  for (var i = 0; i < pointStore.categories.List.length; i++) {
    pointStore.categories.List[i].Selected = false;
    pointStore.categories.List[i].Disabled = false;
  }
  for (var i = 0; i < pointStore.depths.List.length; i++) {
    pointStore.depths.List[i].Selected = false;
    pointStore.depths.List[i].Disabled = false;
  }
  for (var i = 0; i < pointStore.products.List.length; i++) {
    pointStore.products.List[i].Selected = false;
    pointStore.products.List[i].Disabled = false;
  }
  for (var i = 0; i < pointStore.points.length; i++) {
    pointStore.points[i].Disabled = false;
  }
}

function onResize(event) {
  setTimeout(windowIsMobile(), 500);
  setTimeout(updateScroll(), 500);
  setTimeout(openFilter(), 500);
}

function updateScroll() {
  var scrollArea = document.getElementById('scroll-area');
  var container = document.getElementsByClassName('tool-list-container')[0];
  var toolWidth = 0;
  setTimeout(function () {
    if (!!document.getElementsByClassName('tool-preview')[0]) {
      toolWidth = document.getElementsByClassName('tool-preview')[0].offsetWidth;
    }
    if (scrollArea.scrollLeft < (toolWidth / 3)) {
      container.classList.remove('show-left');
    }
    else {
      container.classList.add('show-left');
    }
    if (scrollArea.scrollLeft + scrollArea.offsetWidth < scrollArea.scrollWidth - (toolWidth / 3)) {
      container.classList.add('show-right');
    }
    else {
      container.classList.remove('show-right');
    }
  }, 200);
  if (pointStore.selectedPoint) {
    var pointOffset = document.getElementById(pointStore.selectedPoint.ArticleNr).offsetLeft;
    if (pointOffset < scrollArea.scrollLeft - (toolWidth / 2) || pointOffset - scrollArea.scrollLeft + (toolWidth / 2) > scrollArea.offsetWidth) {
      var pointIndex = pointStore.points.findIndex(x => x.ArticleNr === pointStore.selectedPoint.ArticleNr);;
      pointStore.points[pointIndex].Selected = false;
    }
  }
}

function openFilter() {
  setTimeout(function () {
    if (!isMobile) {
      var filters = document.getElementsByClassName('filter-open');
      for (var i = 0; i < filters.length; i++) {
        filters[i].setAttribute('aria-expanded', 'true');
      }
    }
  }, 500);
}

function beforeDestroy() {
  window.removeEventListener('resize', onResize);
}

</script>